<template>
  <div>
    <section class="hero is-dark">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-8">
              <h1 class="title">
                Car Trackr
              </h1>
              <h2 class="subtitle">
                Car expense tracker and service scheduler
              </h2>
            </div>

            <login-register />
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <h2 class="title is-2">Features</h2>

        <div class="columns features">
          <div class="column is-3">
            <div class="card">
              <div class="card-header">
                <p class="card-header-title">
                  Fuel Tracking
                </p>
              </div>
              <div class="card-content">
                <p>
                  Track your fuel usage, mileage and cost
                </p>
              </div>
            </div>
          </div>

          <div class="column is-3">
            <div class="card">
              <div class="card-header">
                <p class="card-header-title">
                  Statistics
                </p>
              </div>
              <div class="card-content">
                <p>
                  Get your mileage and expense statistics which will help to
                  budget and plan ahead your expenses
                </p>
              </div>
            </div>
          </div>

          <div class="column is-3">
            <div class="card">
              <div class="card-header">
                <p class="card-header-title">
                  Notifications
                </p>
              </div>
              <div class="card-content">
                <p>
                  Receive remainders about scheduled maintenance
                  and purchases such as oil change or insurance renewal.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="columns features">
          <div class="column is-3">
            <div class="card">
              <div class="card-header">
                <p class="card-header-title">
                  Multi vehicle support and sharing
                </p>
              </div>
              <div class="card-content">
                <p>
                  Track all your vehicles and let your family, friends or
                  employees use expense tracking.
                </p>
              </div>
            </div>
          </div>

          <div class="column is-3">
            <div class="card">
              <div class="card-header">
                <p class="card-header-title">
                  Cost of ownership
                </p>
              </div>
              <div class="card-content">
                <p>
                  Get real cost of ownership and cost per mile for your vehicle,
                  calculate price of your next trip or simply make a decision to get new car
                  when expenses increase
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <h2 class="title is-2">
          Pricing
        </h2>

        <div class="columns pricing">
          <div class="column is-12">
            <table class="table is-fullwidth">
              <thead>
              <tr>
                <th></th>
                <th>Free</th>
                <th>Pro (coming soon)</th>
              </tr>
              </thead>

              <tbody>
              <tr>
                <td>Track fuel and mileage</td>
                <td>yes</td>
                <td>yes</td>
              </tr>
              <tr>
                <td>Track expenses</td>
                <td>yes</td>
                <td>yes</td>
              </tr>
              <tr>
                <td>Vehicle limit</td>
                <td>3</td>
                <td>unlimited</td>
              </tr>
              <tr>
                <td>Vehicle sharing</td>
                <td>no</td>
                <td>yes</td>
              </tr>
              <tr>
                <td>Remainders</td>
                <td>yes</td>
                <td>yes</td>
              </tr>
              <tr>
                <td>Detailed statistics</td>
                <td>yes</td>
                <td>yes</td>
              </tr>
              <tr>
                <td>Ads</td>
                <td>yes</td>
                <td>no</td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <td>Price</td>
                <td>Free</td>
                <td>$2 / month</td>
              </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import LoginRegister from '../components/user/LoginRegister.vue';

export default {
  name: 'home',
  components: {
    LoginRegister,
  },
};
</script>

<style lang="scss" scoped>
  .features {
    justify-content: space-around;
  }
</style>
